import { URLSVC } from 'src/config/helper/urlService';
import Swal from 'sweetalert2'
import { FUNCArraySelectKode, FUNCArraySelectId, FUNCArraySelectRole, http } from 'src/config';

/// SATU DATA MUBA ////
export const setDataCombo = (type,Parameter) => {
    return (dispatch) => {
        switch(type){
            case "DATA_COMBO_MASTER_TABLE":
                http.get(`${URLSVC}/Admins/GetMasterTables`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectId(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_SEMESTER":
                var Data = [
                    {
                        value:1,
                        label:"Semester 1"
                    },
                    {
                        value:2,
                        label:"Semester 2"
                    }
                ]
                dispatch({ type, payload: Data })
                break;
            case "DATA_COMBO_KWARTAL":
                var Data = [
                    {
                        value:1,
                        label:"1 Kuartal"
                    },
                    {
                        value:2,
                        label:"2 Kuartal"
                    },
                    {
                        value:3,
                        label:"3 Kuartal"
                    }
                ]
                dispatch({ type, payload: Data })
                break;
            case "DATA_COMBO_TRIWULAN":
                var Data = [
                    {
                        value:1,
                        label:"1 Triwulan"
                    },
                    {
                        value:2,
                        label:"2 Triwulan"
                    },
                    {
                        value:3,
                        label:"3 Triwulan"
                    },
                    {
                        value:4,
                        label:"4 Triwulan"
                    }
                ]
                dispatch({ type, payload: Data })
                break;
            case "DATA_COMBO_BULAN":
                var Data = [
                    {
                        value:1,
                        label:"Januari"
                    },
                    {
                        value:2,
                        label:"Februari"
                    },
                    {
                        value:3,
                        label:"Maret"
                    },
                    {
                        value:4,
                        label:"April"
                    },
                    {
                        value:5,
                        label:"Mei"
                    },
                    {
                        value:6,
                        label:"Juni"
                    },
                    {
                        value:7,
                        label:"Juli"
                    },
                    {
                        value:8,
                        label:"Agustus"
                    },
                    {
                        value:9,
                        label:"September"
                    },
                    {
                        value:10,
                        label:"Oktober"
                    },
                    {
                        value:11,
                        label:"November"
                    },
                    {
                        value:12,
                        label:"Desember"
                    }
                ];
                dispatch({ type, payload: Data })
                break;
            case "DATA_COMBO_APPL":
                http.get(`${URLSVC}/Webs/GetAppls`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        data.Data.map((item, index) => {
                            array.push({Id:item.IdAppl,Name:item.ApplName})
                        });
                        array = FUNCArraySelectId(array)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_APPL_TASK":
                http.get(`${URLSVC}/Webs/GetApplTasks?IdAppl=${Parameter.IdAppl}`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        data.Data.map((item, index) => {
                            array.push({Id:item.IdApplTask,Name:item.ApplTaskName})
                        });
                        array = FUNCArraySelectId(array)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_APPL_TASK_PARENT":
                http.get(`${URLSVC}/Webs/GetApplTasks?IdAppl=${Parameter.IdAppl}`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array.push({Id:null,Name:"- Pilih Salah Satu -"})
                        data.Data.map((item, index) => {
                            if (item.IdApplTaskParent == null) {
                                array.push({Id:item.IdApplTask,Name:item.ApplTaskName})
                            }
                        });
                        array = FUNCArraySelectId(array)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_GEOPORTAL_TYPE_KEY":
                http.get(`${URLSVC}/Others/GetGeoportalTypes`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectKode(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_AFFAIR":
                http.get(`${URLSVC}/Admins/GetAffairs`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectId(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_SECTOR":
                http.get(`${URLSVC}/Admins/GetSectorByAffairsId?AffairsId=${Parameter.AffairsId}`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectId(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_INDICATOR":
                http.get(`${URLSVC}/Admins/GetIndicatorBySector?SectorId=${Parameter?.SectorId}`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectId(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_INDICATOR_DET":
                http.get(`${URLSVC}/Admins/GetIndicatorDetByIndicator?IndicatorId=${Parameter?.IndicatorId}`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectId(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_AGENCY":
                http.get(`${URLSVC}/Admins/GetAgencies`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        if(Parameter == undefined || Parameter == null){
                             array = FUNCArraySelectId(data.Data)
                        } else {
                             array = FUNCArraySelectKode(data.Data)
                        }
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_FREQUENCY":
                http.get(`${URLSVC}/Admins/GetFrequencies`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectId(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_SCOPE":
                http.get(`${URLSVC}/Admins/GetDataScopes`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectId(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_LICENSE":
                http.get(`${URLSVC}/Admins/GetLicenses`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectId(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_TAG":
                http.get(`${URLSVC}/Admins/GetTags`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectId(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_CATEGORY":
                http.get(`${URLSVC}/Admins/GetDataCategories`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectId(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_DATASETTYPE":
                http.get(`${URLSVC}/Admins/GetDatasetTypes`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectId(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_FIELDTYPE":
                http.get(`${URLSVC}/Admins/GetFieldTypes`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectId(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_PUBLICATION_DATASETTYPE":
                http.get(`${URLSVC}/Admins/GetPublicationDatasetTypes`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectId(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_PUBLICATION_DOCUMENTTYPE":
                http.get(`${URLSVC}/Others/GetPublicationDocumentTypes`).then((res) => {
                    let data = res.data
                    var array = [];
                    if (data.IsSuccess) {
                        array = FUNCArraySelectKode(data.Data)
                        dispatch({ type, payload: array })
                    } else {
                        dispatch({ type, payload: array })
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
                break;
            case "DATA_COMBO_TAHUN":
                var d = new Date();
                var TahunSekarang = d.getFullYear();
                var TahunMulai = TahunSekarang - 5;
                var Tahuns = [];
                for (TahunSekarang; TahunSekarang > TahunMulai; TahunSekarang--) {
                    Tahuns.push({Id:TahunSekarang,Name:TahunSekarang});
                }
                let array = FUNCArraySelectId(Tahuns)
                dispatch({ type, payload: array })
                break;
            default:
                break;
        }
    }
}
/// END SATU DATA MUBA ///

export const setDataComboProv = (type) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetProvinsi`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectKode(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataComboKab = (type, KdProv) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetKabupaten?KdProv=${KdProv}`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectKode(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataComboKec = (type, KdKab) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetKecamatan?KdKab=${KdKab}`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectKode(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataComboDesa = (type, KdKec) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetDesa?KdKec=${KdKec}`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectKode(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataComboJenisBantuan = (type) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetJenisBantuans`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectId(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataComboPenghasilanTetap = (type) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetStatusPenghasilanTetap`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectId(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataComboStatusKk = (type) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetStatusKk`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectId(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataComboJenisKelamin = (type) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetJenisKelamin`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectId(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataComboAgama = (type) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetAgama`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectId(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataComboJenisPendidikan = (type) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetJenisPendidikan`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectId(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataComboWarga = (type) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetWarga`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectId(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataJenisGoldar = (type) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetJenisGoldar`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectId(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataComboJenisPekerjaan = (type) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetJenisPekerjaan`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectId(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataStatusKawin = (type) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetStatusKawin`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectId(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataComboStatusKkNik = (type) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetStatusKkNik`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectId(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setDataComboRole = (type = 'DATA_COMBO_ROLE') => {
    return (dispatch) => {
        http.get(`${URLSVC}/Webs/GetRoles`).then((res) => {
            let data = res.data
            if (data.IsSuccess) {
                let array = FUNCArraySelectRole(data.Data)
                dispatch({ type, payload: array })
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}